<template>
  <a-modal title="编辑查询权限"  :visible="visible" :maskClosable="false" @cancel="$emit('cancel')" :width="960" destroyOnClose>
    <template slot="footer">
      <a-button key="submit" :loading="loading" type="primary" @click="submit">确定</a-button>
      <a-button key="back" @click="$emit('cancel')">取消</a-button>
    </template>
    <a-form :form="form" class="custom pick-100 form-input">
      <a-row>
        <a-col :span="10" :offset="1">
          <a-form-item label="权限Key">
            <perm-selector v-decorator="['permKey', { initialValue: initData.permKey, rules: [{ required: true, message: '请选择权限' }] }]" class="selectInput"/>
          </a-form-item>
        </a-col>
        <a-col :span="10" :offset="1">
          <a-form-item label="查询范围">
            <a-select v-decorator="['scope', { initialValue: initData.scope, rules: [{ required: true, message: '请选择查询范围' }] }]">
              <a-select-option value="D">部门</a-select-option>
              <a-select-option value="O">机构</a-select-option>
              <a-select-option value="A">所有</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
import qs from 'qs'
import PermSelector from '@/components/selector/PermSelector'

export default {
  name: 'WFCaseQueryPermissionEdit',
  components: { PermSelector },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      form: this.$form.createForm(this),
      initData: {
      }
    }
  },
  created () {
  },
  methods: {
    init (record) {
      const that = this
      this.$http.get('/api/1/workflow/config/get_permission.json?permKey=' + record.permKey + '&scope=' + record.scope).then(function (response) {
        that.initData = response.result
      })
    },
    submit () {
      const that = this
      this.loading = true
      this.form.validateFields((err, values) => {
        if (err) {
          this.loading = false
          return
        }
        let data = that.form.getFieldsValue()
        data.oldPermKey = this.initData.permKey
        data.oldScope = this.initData.scope
        this.$http.post('/api/1/workflow/config/update_permission.json', qs.stringify(data, { allowDots: true }))
          .then(function (response) {
            that.$message.success('保存成功')
            that.$emit('success')
            that.loading = false
          })
      })
    }
  }
}
</script>

<style scoped></style>
